import { Injectable } from '@angular/core';
import { shareReplay, tap, map, switchMap, catchError } from 'rxjs/operators';
import { combineLatest, ReplaySubject, BehaviorSubject, of } from 'rxjs';
import { NameAndAddressRecordType } from 'src/app/shared/common-components/AppConstants';
import { StateCountryService } from '../state-country/state-country.service';
import { NameAndAddressService } from '../name-and-address/name-and-address.service';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { HhgBillOfLadingInfo, HhgBillOfLadingDetails, HhgBolPackagesEntity, BolCorrectionNoticeEntity } from 'src/app/shared/common-components/common-structure';
import { LoadingService } from '../loading/loading.service';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HhgBillOfLadingService extends DataService {


  private baseURI = this.apiUri + '/hhgboldetails/';
  private allCountriesList$ = this.stateCountryService.getAllCountries().pipe(shareReplay(1));
  private allStates$ = this.stateCountryService.getAllStates().pipe(shareReplay(1));
  private shipmentAddresses$ = combineLatest([this.nameAndAddressService.shipmentAddresses$, this.allCountriesList$, this.allStates$])
    .pipe(
      map(([addresses, countries, states]) => {
        addresses.map(address => {
          address['state'] = states.find(state => state.stateCountryId === address.stateId).stateCountryName;
          address['country'] = countries.find(ctry => ctry.stateCountryId === address.countryId).stateCountryName;
          address['displayAddressType'] = address.recordType === NameAndAddressRecordType.ORIGIN ? 'Origin Address'
            : address.recordType === NameAndAddressRecordType.BILL_TO ? 'Bill To Address'
              : address.recordType === NameAndAddressRecordType.SHIPPER ? 'Shipper Address'
                : address.recordType === NameAndAddressRecordType.DESTINATION ? 'Destination Address'
                  : address.recordType === NameAndAddressRecordType.CONSIGNEE ? 'Consignee Address'
                    : 'Issuing Office Address';
        });
        return addresses;
      }), shareReplay(1));

  shipmentId = new BehaviorSubject<number>(0);
  hhgBolDetailsId = new BehaviorSubject<number>(0);

  hhgBillOfLadingDetail$ = this.shipmentId.pipe(
    tap(shipmentId => this.nameAndAddressService.updateShipmentId(shipmentId)),
    switchMap(shipmentId =>
       this.http.get<HhgBillOfLadingDetails>(this.baseURI + shipmentId + '/shipmentsInfoId')
        .pipe(
           tap(hhgBillOfLadingDetail => this.hhgBolDetailsId.next(hhgBillOfLadingDetail.hhgBolDetailsId)),
           tap(t => this.loader.hide()),
          catchError(e => {
            this.loader.hide();
            return of({} as HhgBillOfLadingDetails);
          }))
    ));

  hhgBillOfLadingPackageDetail$ = this.hhgBolDetailsId.pipe(
    filter(s => s > 0),
    switchMap(hhgBolDetailsId => {
      return this.http.get<HhgBolPackagesEntity[]>(this.baseURI + hhgBolDetailsId + '/getBolPackages')
        .pipe(tap(t => this.loader.hide()),
          catchError(e => {
            this.loader.hide();
            return of({} as HhgBolPackagesEntity[]);
          }));
    }));

  hhgBillOfLadingReview$ = this.shipmentId.pipe(
    filter(s => s > 0),
    switchMap(shipmentId => {
      return this.http.get<HhgBillOfLadingInfo>(this.baseURI + shipmentId + '/getBolDetails')
        .pipe(tap(t => this.loader.hide()),
          catchError(e => {
            this.loader.hide();
            return of({} as HhgBillOfLadingInfo);
          }));
    }));

  HhgBolFinalizationDetails$ = this.hhgBolDetailsId.pipe(
    filter(s => s > 0),
    switchMap(hhgBolDetailsId => {
      return this.http.get<BolCorrectionNoticeEntity>(this.baseURI + hhgBolDetailsId + '/getbolcorrectionnotice')
        .pipe(tap(t => this.loader.hide()),
          catchError(e => {
            this.loader.hide();
            return of({} as BolCorrectionNoticeEntity);
          }));
    }));

  constructor(private stateCountryService: StateCountryService, private loader: LoadingService,
    private nameAndAddressService: NameAndAddressService, http: HttpClient) {
    super(http);
  }

  originShipmentAddresses$ = this.shipmentAddresses$.pipe(map((addresses: any) =>
    addresses.filter(a => (a.recordType === NameAndAddressRecordType.ORIGIN
      || a.recordType === NameAndAddressRecordType.BILL_TO
      || a.recordType === NameAndAddressRecordType.SHIPPER)))
  );

  destinationShipmentAddresses$ = this.shipmentAddresses$.pipe(map((addresses: any) =>
    addresses.filter(a => (a.recordType === NameAndAddressRecordType.DESTINATION
      || a.recordType === NameAndAddressRecordType.CONSIGNEE
      || a.recordType === NameAndAddressRecordType.ISSUE_OFFICE)))
  );

  updateShipmentId(shipmentId: number) {
    console.log('shipmentId is : ' + shipmentId);
    this.shipmentId.next(shipmentId);
  }

  saveBolInfo(hhgBillOfLadingDetails: HhgBillOfLadingDetails): Observable<any> {
    console.log('Add bolinfo = ', hhgBillOfLadingDetails );
    console.log('Uri is : ' + this.baseURI);
    return this.http
        .put(this.baseURI + 'updateBolDetails', hhgBillOfLadingDetails);
  }

  // Function to delete a existing Package when we uncheck the checkbox
  deletePackage(hhgBookPackagesId: number, hhgBolPackagesEntity: HhgBolPackagesEntity): Observable<any> {
    return this.http
      .put(this.baseURI + 'deletePackage', hhgBolPackagesEntity);
  }
}
